import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import _ from 'underscore'
import $ from 'jquery'
import { Modal, ModalBody } from './Modal'
import { toggleResumeNameModal } from '../../actions/modals'
import { updateCandidateTargetFileName } from '../../actions/actions'
import { getCleanFileName } from '../../services/helpers'

const RenameResumeModal = () => {
  const renameResumeModal = useSelector((state) => state.renameResumeModal)
  const { isOpen, candidateId, currentFileName } = renameResumeModal

  const [fileName, setFileName] = useState(currentFileName ? currentFileName : '')

  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(toggleResumeNameModal({ isOpen: false, candidateId: null }))
  }

  const handleInputChange = (event) => {
    let value = event.target.value
    if (!value.trim()) {
      value = ''
    } else {
      value = getCleanFileName(value, false)
    }
    setFileName(value)
  }

  const handleEnter = (event) => {
    if (fileName.length && currentFileName !== fileName) {
      if (event.keyCode === 13 || event.key === 'Enter') {
        event.preventDefault()
        event.stopPropagation()
        dispatch(updateCandidateTargetFileName({ candidateId, targetFileName: fileName }))
        handleClose()
      }
    }
  }

  return (
    <Modal
      className="resume-name-setter"
      isOpen={isOpen && candidateId}
      onRequestHide={() => handleClose()}
      aria-label={'Resume name popup'}>
      <ModalBody>
        <div
          onClick={() => handleClose()}
          aria-label={`Click to close this popup`}
          className="close tab-index-focus"
          tabIndex="0"
          onKeyDown={e => {
            if (e.keyCode === 13 || e.key === 'Enter') {
              e.preventDefault()
              e.stopPropagation()
              handleClose()
            }
          }}>
          <span className="icon-cross" />
        </div>
        <div className="prompt-heading">Edit Output Resume Name</div>
        <input
          tabIndex={0}
          style={{ marginTop: '25px' }}
          type="text"
          value={fileName}
          placeholder={"Resume name..."}
          aria-label={"Resume name..."}
          onChange={(e) => handleInputChange(e)}
          onKeyDown={(e) => handleEnter(e)}
        />
        <div className="bottom-buttons-container">
          <button
            className="save-button"
            disabled={fileName.length === 0 || currentFileName === fileName}
            onClick={() => {
              if (fileName.length && currentFileName !== fileName) {
                dispatch(updateCandidateTargetFileName({ candidateId, targetFileName: fileName }))
                handleClose()
              }
            }}>
            Save
          </button>
          <button
            className="cancel-button"
            onClick={() => handleClose()}>
            Cancel
          </button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default RenameResumeModal